/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ViewerOnOnly400FoaQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerOnOnly400FoaQuery = { viewer: { is400FOA: boolean } };


export const ViewerOnOnly400FoaDocument = gql`
    query viewerOnOnly400FOA {
  viewer {
    is400FOA
  }
}
    `;

/**
 * __useViewerOnOnly400FoaQuery__
 *
 * To run a query within a Vue component, call `useViewerOnOnly400FoaQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerOnOnly400FoaQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useViewerOnOnly400FoaQuery();
 */
export function useViewerOnOnly400FoaQuery(options: VueApolloComposable.UseQueryOptions<ViewerOnOnly400FoaQuery, ViewerOnOnly400FoaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewerOnOnly400FoaQuery, ViewerOnOnly400FoaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewerOnOnly400FoaQuery, ViewerOnOnly400FoaQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ViewerOnOnly400FoaQuery, ViewerOnOnly400FoaQueryVariables>(ViewerOnOnly400FoaDocument, {}, options);
}
export function useViewerOnOnly400FoaLazyQuery(options: VueApolloComposable.UseQueryOptions<ViewerOnOnly400FoaQuery, ViewerOnOnly400FoaQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ViewerOnOnly400FoaQuery, ViewerOnOnly400FoaQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ViewerOnOnly400FoaQuery, ViewerOnOnly400FoaQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ViewerOnOnly400FoaQuery, ViewerOnOnly400FoaQueryVariables>(ViewerOnOnly400FoaDocument, {}, options);
}
export type ViewerOnOnly400FoaQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ViewerOnOnly400FoaQuery, ViewerOnOnly400FoaQueryVariables>;